export default {
  articles: {
    data: [{
      'id': 3,
      'user': {
        'id': 1,
        'username': 'Bagouze',
        'first_name': '',
        'last_name': '',
        'is_superuser': true
      },
      'likes': 0,
      'comments_count': 0,
      'keywords_string': '',
      'rating_count': 0,
      'rating_sum': 0,
      'rating_average': 0.0,
      'title': 'Titre de test !!',
      'slug': 'le-gros-guerrier-des-îles',
      '_meta_title': null,
      'description': '\n\n\n\n\n\nLa méthode slice() renvoie un objet tableau, contenant une copie superficielle (shallow copy) d\'une portion du tableau d\'origine, la portion est définie par un indice de début et un indice de fin (exclus). Le tableau original ne sera pas modifié.',
      'created': '2017-05-09T09:23:05Z',
      'updated': '2017-05-09T09:23:05Z',
      'status': 2,
      'publish_date': '2017-05-09T09:23:05Z',
      'expiry_date': null,
      'featured_image': 'http://localhost:8000/static/medias/uploads/27129blanc.jpg',
      'categories': [],
      'related_posts': []
    },
    {
      'id': 2,
      'user': {
        'id': 1,
        'username': 'Bagouze',
        'first_name': '',
        'last_name': '',
        'is_superuser': true
      },
      'likes': 0,
      'comments_count': 0,
      'keywords_string': '',
      'rating_count': 0,
      'rating_sum': 0,
      'rating_average': 0.0,
      'title': 'Titre du nouvel article',
      'slug': 'titre-du-nouvel-article-1',
      '_meta_title': null,
      'description': '\n                    \n                        \n\n\n                    \n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure quia incidunt adipisci alias necessitatibus qui earum dolores eos deleniti, recusandae dolorem temporibus quam hic possimus! Assumenda illum, repudiandae adipisci maxime. Soluta consequatur sint aliquam delectus eos et, iusto ea quasi accusamus ducimus nam, officiis laboriosam totam quo! Sed temporibus expedita ipsam, labore corporis rerum nihil consequuntur ratione similique quia optio. Deleniti ab illum, totam odio. Minima veniam, aliquid esse dicta temporibus iusto. Fugit non, dignissimos eaque at tempora, sunt cum architecto natus animi placeat quam, dolorum nisi adipisci vel dolorem! Reprehenderit laborum quasi nesciunt dolore tenetur a ipsa in magni ea quos. Vero voluptatem animi praesentium excepturi, facere id doloremque maxime sint fuga impedit, quibusdam voluptatum dignissimos eos, nam! Vitae.',
      'created': '2017-04-28T09:28:19Z',
      'updated': '2017-04-28T09:28:19Z',
      'status': 2,
      'publish_date': '2017-04-28T09:28:19Z',
      'expiry_date': null,
      'featured_image': null,
      'categories': [],
      'related_posts': []
    },
    {
      'id': 1,
      'user': {
        'id': 1,
        'username': 'Bagouze',
        'first_name': '',
        'last_name': '',
        'is_superuser': true
      },
      'likes': 0,
      'comments_count': 0,
      'keywords_string': '',
      'rating_count': 0,
      'rating_sum': 0,
      'rating_average': 0.0,
      'title': 'Titre du nouvel article',
      'slug': 'titre-du-nouvel-article',
      '_meta_title': null,
      'description': '\n                    \n                        \n\n\n                    \n                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure quia incidunt adipisci alias necessitatibus qui earum dolores eos deleniti, recusandae dolorem temporibus quam hic possimus! Assumenda illum, repudiandae adipisci maxime. Soluta consequatur sint aliquam delectus eos et, iusto ea quasi accusamus ducimus nam, officiis laboriosam totam quo! Sed temporibus expedita ipsam, labore corporis rerum nihil consequuntur ratione similique quia optio. Deleniti ab illum, totam odio. Minima veniam, aliquid esse dicta temporibus iusto. Fugit non, dignissimos eaque at tempora, sunt cum architecto natus animi placeat quam, dolorum nisi adipisci vel dolorem! Reprehenderit laborum quasi nesciunt dolore tenetur a ipsa in magni ea quos. Vero voluptatem animi praesentium excepturi, facere id doloremque maxime sint fuga impedit, quibusdam voluptatum dignissimos eos, nam! Vitae.',
      'created': '2017-04-28T09:28:13Z',
      'updated': '2017-04-28T09:28:13Z',
      'status': 2,
      'publish_date': '2017-04-28T09:28:12Z',
      'expiry_date': null,
      'featured_image': null,
      'categories': [],
      'related_posts': []
    }]
  },
  detailedArticle: {
    data: {
      'id': 3,
      'user': {
        'id': 1,
        'username': 'Bagouze',
        'first_name': '',
        'last_name': '',
        'is_superuser': true
      },
      'comments': [],
      'likes': 8,
      'comments_count': 0,
      'keywords_string': '',
      'rating_count': 0,
      'rating_sum': 0,
      'rating_average': 0.0,
      'title': 'le gros titre de test !!',
      'slug': 'le-gros-guerrier-des-îles',
      '_meta_title': null,
      'description': '\n\n\n\n\n\nLa méthode slice() renvoie un objet tableau, contenant une copie superficielle (shallow copy) d\'une portion du tableau d\'origine, la portion est définie par un indice de début et un indice de fin (exclus). Le tableau original ne sera pas modifié.',
      'gen_description': true,
      'created': '2017-05-09T09:23:05Z',
      'updated': '2017-05-09T09:23:05Z',
      'status': 2,
      'publish_date': '2017-05-09T09:23:05Z',
      'expiry_date': null,
      'short_url': null,
      'in_sitemap': true,
      'content': '<div _ngcontent-nmh-27=\'\' class=\'row columns\'>\n                    <div _ngcontent-nmh-27=\'\' class=\'large-5 columns\'>\n                        <img-editor _ngcontent-nmh-27=\'\'>\n<input ng2fileselect=\'\' style=\'display:none\' type=\'file\'>\n<img alt=\'\' ng-reflect-src=\'http://localhost:8000/static/medias/uploads/27129blanc.jpg\' src=\'http://localhost:8000/static/medias/uploads/27129blanc.jpg\'></img-editor>\n                    </div>\n                    <div _ngcontent-nmh-27=\'\' class=\'large-7 columns cke_editable cke_editable_inline cke_contents_ltr cke_show_borders\' contenteditable=\'true\' id=\'par1\' style=\'text-align: justify; position: relative;\' tabindex=\'0\' spellcheck=\'false\' role=\'textbox\' aria-label=\'Éditeur de texte enrichi, par1\' title=\'Éditeur de texte enrichi, par1\' aria-describedby=\'cke_180\'><p>La méthode&nbsp;<strong><code>slice()</code></strong>&nbsp;renvoie un objet tableau, contenant une copie superficielle (<em>shallow copy</em>) d\'une portion du tableau d\'origine, la portion est définie par un indice de début et un indice de fin (exclus). Le tableau original ne sera pas modifié.<br></p></div>\n                </div>\n                <div _ngcontent-nmh-27=\'\' class=\'row columns\' style=\'text-align:justify\'>\n                    <div _ngcontent-nmh-27=\'\' class=\'large-12 columns cke_editable cke_editable_inline cke_contents_ltr cke_show_borders\' contenteditable=\'true\' id=\'par2\' tabindex=\'0\' spellcheck=\'false\' role=\textbox\' aria-label=\'Éditeur de texte enrichi, par2\' title=\'Éditeur de texte enrichi, par2\' aria-describedby=\'cke_271\' style=\'position: relative;\'><div>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure quia incidunt adipisci alias necessitatibus qui earum dolores eos deleniti, recusandae dolorem temporibus quam hic possimus! Assumenda illum, repudiandae adipisci maxime.</div><div>Soluta consequatur sint aliquam delectus eos et, iusto ea quasi accusamus ducimus nam, officiis laboriosam totam quo! Sed temporibus expedita ipsam, labore corporis rerum nihil consequuntur ratione similique quia optio.</div><div>Deleniti ab illum, totam odio. Minima veniam, aliquid esse dicta temporibus iusto. Fugit non, dignissimos eaque at tempora, sunt cum architecto natus animi placeat quam, dolorum nisi adipisci vel dolorem!</div><div>Reprehenderit laborum quasi nesciunt dolore tenetur a ipsa in magni ea quos. Vero voluptatem animi praesentium excepturi, facere id doloremque maxime sint fuga impedit, quibusdam voluptatum dignissimos eos, nam! Vitae.</div><div>Neque maxime dignissimos ut quam aliquid pariatur, a at est totam dolor non quos consequuntur et error dolore quia? Sint voluptatem excepturi assumenda iusto qui nesciunt magnam voluptatibus, facere veniam.</div><div>Sapiente incidunt animi atque aliquam odit est ea vel maxime deserunt ipsum praesentium eos quae velit, in soluta blanditiis alias eligendi et accusamus. Quidem, nostrum. Consectetur ut rerum modi, quia!</div><p><br></p></div>\n                </div>',
      'allow_comments': true,
      'featured_image': 'http://localhost:8000/static/medias/uploads/27129blanc.jpg',
      'site': 1,
      'categories': [],
      'related_posts': []
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/test-api/datas/news.data.js